export const NOTES_KEY = 'notes-01EWNTQ20SV8YJAEC2F2Q3X6C2'

export const isNotesAttribute = attr => attr?.attributes?.key_string_downcased === NOTES_KEY.toLowerCase()
